import LocationMenuLinks from '@/components/LocationMenuLinks'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		data: {},
		...opts,
		vueComponent: LocationMenuLinks
	}

	let page = vuewidget(dom, options)
	return page
}
